<template>
    <div class="row d-block">
        <div v-if="element.type_user == this.userSent || element.type_user == this.userAutomatic">
            <div class="col-md-8 col-sm-8 col-8 mr-auto">
                <div class="card-message-self text-left">
                    <div class="row d-block">
                        <div class="col-md-12 text-client-name">
                            <strong><i>{{element.from}}</i></strong>
                        </div>
                        <div class="col-md-12 text-client-body">
                            <div v-if="element.attachment.length > 0">
                                <div v-if="checkExt(element.mediacontent) == this.type_attach_image">
                                    <div class="div-attachment" v-on:click="showIngrandisci(element.attachment)">
                                        <img :src="element.attachment" class="p-2 img-attachment">
                                    </div>
                                </div>
                                <div v-if="checkExt(element.mediacontent) == this.type_attach_other">
                                    <div class="div-attachment mb-2">
                                        <a :href="element.attachment" target="_blank" class="link-attach">
                                            <ficon :icon="['fas', 'file-alt']" class="color-icon"></ficon>
                                            Visualizza
                                        </a>
                                    </div>
                                </div>
                            </div>
                            <span v-html="this.getMessage(element.body)"></span>
                            <div v-if="element.type == this.type_message_call && this.sendCall == false">
                                <div class="row pt-2 pb-2">
                                    <div class="col-12">
                                        <label><strong>Numero di Telefono</strong></label>
                                        <input type="text" class="form-control" placeholder v-model="number_call">
                                    </div>
                                </div>
                                <div class="row form-group">
                                    <div class="col-12">
                                        <b-button variant="success"  @click="sendCallFun()">Invia</b-button>
                                    </div>
                                </div>
                            </div>
                            <div v-if="element.type == this.type_ticket_fault && this.sendTicketFault == false">
                                <div class="row pt-2 pb-2">
                                    <div class="col-12">
                                        <label><strong>Numero di telefono registrato nel ticket</strong></label>
                                        <input type="text" class="form-control" placeholder v-model="number_ticket">
                                    </div>
                                </div>
                                <div class="row form-group">
                                    <div class="col-12">
                                        <b-button variant="success"  @click="sendTicketFaultFun()">Invia</b-button>
                                    </div>
                                </div>
                            </div>
                            <div v-else-if="element.type == this.type_message_controllo_linea && this.clickControlloLinea == false">
                                <div class="row pt-2">
                                    <div class="col-12">
                                        <label>Servizi Attivi</label>
                                        <select class="form-control" v-model="servizio_controllo_linea">
                                            <option value="" selected>Non Definito</option>
                                            <option  v-for="(value , key) in this.element.attr" v-bind:key="key" :value="key">{{value}}</option>
                                        
                                        </select>
                                    </div>
                                </div>
                                <div class="row form-group pt-2">
                                    <div class="col-12">
                                        <b-button variant="success"  @click="ControlloLinea()">Verifica</b-button>
                                    </div>
                                </div>
                                <div class="row form-group" v-if="this.controllo_linea_error.length > 0">
                                    <div class="col-12">
                                        <p class="text-danger"><strong>{{this.controllo_linea_error}}</strong></p>
                                    </div>
                                </div>
                            </div>
                            <div v-if="element.type == this.type_message_vc && this.searchVC == false" >
                                <div class="row pt-2">
                                    <div class="col-12">
                                        <label><strong>Tipologia *</strong></label>
                                        <select class="form-control" v-model="tipologia_vc">
                                            <option value="residenziale">Residenziale</option>
                                            <option value="business">Business</option>
                                        </select>
                                    </div>
                                </div>
                                <div class="row pt-1">
                                    <div class="col-12">
                                        <label><strong>Provincia *</strong></label>
                                        <select class="form-control" v-model="provincia_vc" @change="PopolateComuni">
                                            <option value="" selected>Non Definito</option>
                                            <option  v-for="(value , key) in this.array_province" v-bind:key="key" :value="key">{{value}}</option>
                                        </select>
                                    </div>
                                </div>
                                <div class="row pt-1">
                                    <div class="col-12">
                                        <label><strong>Comune *</strong></label>
                                        <select class="form-control" v-model="comune_vc" >
                                            <option value="" selected>Non Definito</option>
                                            <option  v-for="(value , key) in this.list_comuni" v-bind:key="key" :value="value">{{value}}</option>
                                        </select>
                                    </div>
                                </div>
                                <div class="row pt-1">
                                    <div class="col-12">
                                        <label><strong>Indirizzo *</strong></label>
                                        <input type="text" class="form-control" placeholder v-model="indirizzo_vc">
                                    </div>
                                </div>
                                <div class="row pt-1 form-group" v-if="this.array_civici.length == 0">
                                    <div class="col-12">
                                        <label><strong>Civico *</strong></label>
                                        <input type="text" class="form-control" placeholder v-model="numero_vc">
                                    </div>
                                </div>
                                <div class="row pt-1 form-group" v-if="this.array_civici.length > 0">
                                    <div class="col-12">
                                        <label><strong>Civico *</strong></label>
                                        <select class="form-control" v-model="numero_vc" >
                                            <option value="" selected>Non Definito</option>
                                            <option  v-for="(value , key) in this.array_civici" v-bind:key="key" :value="value">{{value}}</option>
                                        </select>
                                        
                                    </div>
                                </div>  
                                <div class="row form-group">
                                    <div class="col-12">
                                        <b-button variant="success"  @click="InviaVC()">Verifica</b-button>
                                    </div>
                                </div>
                                <div class="row form-group" v-if="this.vc_error.length > 0">
                                    <div class="col-12">
                                        <p class="text-danger"><strong>{{this.vc_error}}</strong></p>
                                    </div>
                                </div>
                            </div>
                            <div v-if="element.type == this.type_message_audio">
                                <div class="row pt-2 pb-2 pl-2">
                                    <audio :src="element.attachment" controls></audio>
                                </div>
                            </div>
                            <div id="text-form-vc" v-if="this.searchVC == true">
                                <p><strong>{{ this.indirizzo_vc }} {{ this.numero_vc }}, {{this.comune_vc}}, {{ this.provincia_vc }}</strong></p>
                            </div>
                            <div id="text-form-controllolinea" v-if="this.clickControlloLinea == true">
                                <p><strong>{{this.info_controllo_linea}}</strong></p>
                            </div>
                            <span v-if="element.body.includes('{link:')">
                                <b-button class="btn btn-lead w-100" @click="generaButtonAction(element.body)">Compila</b-button>
                            </span>
                        </div>
                        <div class="col-12 text-right text-date">
                            <i>{{element.date_orig}} </i>
                        </div>
                        
                    </div>
                </div>
            </div>
        </div>
        <div v-if="element.type_user == this.userReceived">
            <div class="col-md-8 col-sm-8 col-8 ml-auto">
                <div class=" card-message text-left">
                    <div class="row d-block">
                        <div class="col-md-12 text-client-name">
                            <strong><i>Tu</i></strong>
                        </div>
                        <div class="col-md-12 text-client-body">
                            <div v-if="element.attachment.length > 0">
                                <div v-if="checkExt(element.mediacontent) == this.type_attach_image">
                                    <div class="div-attachment" v-on:click="showIngrandisci(element.attachment)">
                                        <img :src="element.attachment" class="p-2 img-attachment">
                                    </div>
                                </div>
                                <div v-if="checkExt(element.mediacontent) == this.type_attach_other">
                                    <div class="div-attachment mb-2">
                                        <a :href="element.attachment" target="_blank" class="link-attach">
                                            <ficon :icon="['fas', 'file-alt']" class="color-icon"></ficon>
                                            Visualizza
                                        </a>
                                    </div>
                                </div>
                            </div>
                            <span v-html="element.body"></span>
                            <div v-if="element.type == this.type_message_audio || checkExt(element.mediacontent) == this.type_attach_audio">
                                <div class="row pt-2 pb-2 px-2">
                                    <audio :src="element.attachment" controls></audio>
                                </div>
                            </div>
                        </div>
                        <div class="col-12 text-right text-date" v-if="element.date_read.length > 0">
                            <i>{{element.date_orig}} - Letto</i>
                        </div>
                        <div class="col-12 text-right text-date" v-if="element.date_read.length == 0">
                            <i>{{element.date_orig}} </i>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <b-modal id="modal-image" centered title="BootstrapVue" @shown="this.focusMyElement">
            <img src="" id="image-modal" class="img-fluid">
        </b-modal>
        <b-modal id="modal-1"></b-modal>

        <b-modal ref="modal-contatto" hide-footer title="Inserisci Recapito">
            <div class="row form-group">
                <div class="col-12">
                    <label><strong>Telefono</strong></label>
                    <input type="text" class="form-control" placeholder v-model="telefono_contatto">
                </div>
            </div>
            <div class="row form-group">
                <div class="col-12">
                    <label><strong>Email</strong></label>
                    <input type="text" class="form-control" placeholder v-model="email_contatto">
                </div>
            </div>
            <div class="row form-group" v-if="this.contatto_error.length > 0">
                <div class="col-12">
                    <p class="text-danger"><strong>{{this.contatto_error}}</strong></p>
                </div>
            </div>
            <div class="row form-group">
                <div class="col-12">
                    <p class="font-small">Cliccando "INVIA" attesti di aver preso visione dell'Informativa della privacy e desidero essere contattato ai recapiti indicati per ricevere assistenza e informazioni sui vostri prodotti e servizi: <a href="https://convergenze.it/it/privacy-policy">Privacy Policy</a></p>
                </div>
            </div>
            <div class="row">
                <div class="col-6"></div>
                <div class="col-6 d-flex justify-content-end">
                    <b-button class="mr-3" variant="outline-danger"  @click="hideModalContatto">Chiudi</b-button>
                    <b-button variant="outline-success"  @click="InviaRecapito()">Invia</b-button>
                </div>
            </div>
        </b-modal>

        <b-modal ref="modal-lead" hide-footer title="Inserisci Info Contatti">
            <div class="row form-group">
                <div class="col-12">
                    <label><strong>Nominativo *</strong></label>
                    <input type="text" class="form-control" placeholder v-model="nominativo_lead">
                </div>
            </div>
            <div class="row form-group">
                <div class="col-12">
                    <label><strong>Telefono</strong></label>
                    <input type="text" class="form-control" placeholder v-model="telefono_lead">
                </div>
            </div>
            <div class="row form-group">
                <div class="col-12">
                    <label><strong>Email</strong></label>
                    <input type="text" class="form-control" placeholder v-model="email_lead">
                </div>
            </div>
            <div class="row form-group">
                <div class="col-12">
                    <p class="font-small">Cliccando "INVIA" attesti di aver preso visione dell'Informativa della privacy e desidero essere contattato ai recapiti indicati per ricevere assistenza e informazioni sui vostri prodotti e servizi: <a href="https://convergenze.it/it/privacy-policy">Privacy Policy</a></p>
                </div>
            </div>
            <div class="row form-group" v-if="this.lead_error.length > 0">
                <div class="col-12">
                    <p class="text-danger"><strong>{{this.lead_error}}</strong></p>
                </div>
            </div>
            <div class="row">
                <div class="col-6"></div>
                <div class="col-6 d-flex justify-content-end">
                    <b-button class="mr-3" variant="outline-danger"  @click="hideModalLead">Chiudi</b-button>
                    <b-button variant="outline-success"  @click="InviaLead()">Invia</b-button>
                </div>
            </div>
        </b-modal>
    </div>
</template>

<script>

    import defapp from "../models/defapp"
    import utilfunc from "../models/utilfunc"
    import BackendApi from "../models/BackendApi"
    import MessageChat from "../models/MessageChat"

    export default {
        name: 'CardClientMessage',
        data: function() {
            return  {
                focusMyElement: false,
                userSent : defapp.TYPE_MESSAGE_SENT,
                userReceived : defapp.TYPE_MESSAGE_RECEIVED,
                userAutomatic : defapp.TYPE_MESSAGE_AUTOMATIC,
                type_attach_image : defapp.TYPE_ATTACH_IMAGE,
                type_attach_other : defapp.TYPE_ATTACH_OTHER,
                type_attach_audio : defapp.TYPE_ATTACH_AUDIO,
                type_message_vc : MessageChat.TYPE_VC_MESSGAE,
                type_message_call: MessageChat.TYPE_CALL_MESSAGE,
                type_message_audio: MessageChat.TYPE_AUDIO_MESSAGE,
                type_message_controllo_linea: MessageChat.TYPE_MESSAGE_CONTROLLO_LINEA,
                type_ticket_fault: MessageChat.TYPE_TICKET_FAULT,
                modalLead: false,
                searchVC: false,
                clickControlloLinea: false,
                nominativo_lead: "",
                telefono_lead: "",
                email_lead: "",
                lead_error : "",
                vc_error : "",
                number_call: "",
                number_ticket: "",
                sendCall: false,
                sendTicketFault: false,
                telefono_contatto: "",
                email_contatto: "",
                contatto_error: "",
                provincia_vc: "",
                comune_vc: "",
                indirizzo_vc: "",
                numero_vc: "",
                tipologia_vc:"residenziale",
                list_comuni: [],
                array_civici: [],
                servizio_controllo_linea: "",
                controllo_linea_error: "",
                info_controllo_linea: ""
            };
        },
        components: {    
            
        },
        props: ['element','client','chatID','userId','array_province','array_comuni'],
        methods: {       
            showIngrandisci(url_image)
            {
                const h = this.$createElement
                // Using HTML string
                //const titleVNode = h('div', { domProps: { innerHTML: 'Title from <i>HTML<i> string' } })
                // More complex structure
                const messageVNode = h('div', { class: ['foobar'] }, [
               
                h('b-img', {
                    props: {
                    src: url_image,
                    thumbnail: true,
                    center: true,
                    fluid: true,
                    }
                })
                ])
                // We must pass the generated VNodes as arrays
                this.$bvModal.msgBoxOk([messageVNode], {
                    buttonSize: 'sm',
                    centered: true, 
                    size: 'lg'
                })
            },
            checkExt(path)
            {
                let util = new utilfunc()
                let result = util.getExtension(path)
                
                return result
            },
            getMessage(body)
            {
                if(body.includes("{link:"))
                {
                    return body.substring(0, body.indexOf('{link:'))
                } else {
                    return body
                }
            },
            generaButtonAction(msg)
            {
                let key = msg.substring(msg.indexOf('link:'),msg.indexOf('}'));
                let arraykey = key.split(":");
                let modal = "";
                if(arraykey.length > 1)
                {
                    switch(arraykey[1])
                    {
                        case 'lead':
                            this.$refs['modal-lead'].show()
                            break;
                        case 'contatto':
                            this.$refs['modal-contatto'].show()
                            break;
                        default:
                            alert("Nessun azione consentita!");
                            break;
                    }
                }
                return modal
            },
            hideModalLead()
            {
                this.$refs['modal-lead'].hide();
                this.lead_error = "";
            },
            hideModalContatto()
            {
                this.$refs['modal-contatto'].hide();
                this.lead_error = "";
            },
            PopolateComuni()
            {
                this.list_comuni = [];
                if(this.array_comuni[this.provincia_vc].length > 0)
                {
                    this.list_comuni = this.array_comuni[this.provincia_vc];
                }                
                
            },
            sendTicketFaultFun()
            {
                if(this.number_ticket > 0)
                {
                    console.log(this.number_ticket)
                    this.sendTicketFault = true
                    let attr = {
                        "numero" : this.number_ticket,
                    }
                    let msg = new MessageChat()
                    this.client.sendMessage(msg.prepareSendMessageTicketFault(
                        MessageChat.TYPE_TICKET_FAULT,
                        0,
                        "",
                        0,
                        this.chatID,
                        defapp.TYPE_MESSAGE_AUTOMATIC,
                        "",
                        "",
                        "",
                        attr))
                }
            },
            sendCallFun()
            {
                if(this.number_call.length > 0)
                {
                    this.sendCall = true
                    let attr = {
                        "numero" : this.number_call,
                    }
                    let msg = new MessageChat()
                    this.client.sendMessage(msg.prepareSendMessageVC(
                        MessageChat.TYPE_CALL_MESSAGE,
                        0,
                        "",
                        0,
                        this.chatID,
                        defapp.TYPE_MESSAGE_AUTOMATIC,
                        "",
                        "",
                        "",
                        attr))
                }
            },
            ControlloLinea()
            {
                var listServ = this.element.attr
                this.controllo_linea_error = "";
                if(this.servizio_controllo_linea.length > 0)
                {
                    this.clickControlloLinea = true
                    this.info_controllo_linea = listServ[this.servizio_controllo_linea]
                    let attr = {
                        "id_servizio" : this.servizio_controllo_linea,
                    }
                    let msg = new MessageChat()
                    this.client.sendMessage(msg.prepareSendMessageVC(
                        MessageChat.TYPE_MESSAGE_CONTROLLO_LINEA,
                        0,
                        "",
                        0,
                        this.chatID,
                        defapp.TYPE_MESSAGE_AUTOMATIC,
                        "",
                        "",
                        "",
                        attr))
                }
                else
                {
                    this.controllo_linea_error = "Selezionare il servizio!";
                }
                
            },
            InviaVC()
            {
                if(this.provincia_vc.length > 0 && this.comune_vc.length > 0 && this.indirizzo_vc.length > 0 & this.numero_vc.length > 0)
                {
                    this.vc_error = ""

                    let api = new BackendApi(this.configApp)
                    let formData = new FormData();

                    formData.append('provincia' , this.provincia_vc)
                    formData.append('comune' , this.comune_vc)
                    formData.append('indirizzo' , this.indirizzo_vc)
                    formData.append('civico' , this.numero_vc)
                    
                    api.trovaCivici(formData,(result) => {
                        
                        if(result.success == true)
                        {
                            let attr = {
                                "provincia" : this.provincia_vc,
                                "comune": this.comune_vc,
                                "indirizzo": this.indirizzo_vc,
                                "civico": this.numero_vc,
                                "tipologia": this.tipologia_vc
                            }
                            let msg = new MessageChat()
                            this.client.sendMessage(msg.prepareSendMessageVC(
                                MessageChat.TYPE_FORMVC_MESSGAER,
                                0,
                                "",
                                0,
                                this.chatID,
                                defapp.TYPE_MESSAGE_AUTOMATIC,
                                "",
                                "",
                                "",
                                attr))

                            this.searchVC = true;
                        }
                        else
                        {
                            if(result.data.length > 0)
                            {
                                this.vc_error = "Il civico inserito non è stato trovato. Seleziona il civico tra quelli disponibili per l'indirizzo indicato";
                                this.array_civici = result.data
                            }
                            else
                            {
                                this.vc_error = "L'indirizzo inserito non è stato trovato. Si prega di riprovare!";
                            }
                        }
                    });

                   
                        
                }
                else {
                    this.vc_error = "Inserire obbligatoriamente tutti i campi!";
                }
            },
            InviaLead()
            {
                
                if(this.nominativo_lead.length > 0 && (this.telefono_lead.length > 0 || this.email_lead.length > 0))
                {
                    let api = new BackendApi(this.configApp)
                    let formData = new FormData();
                    formData.append('nominativo' , this.nominativo_lead)
                    formData.append('telefono' , this.telefono_lead)
                    formData.append('email' , this.email_lead)
                    formData.append('message_id' , this.element.id)

                    api.generaLead(formData,(result) => {
                        if(result.success == true)
                        {
                            this.$refs['modal-lead'].hide();
                            this.lead_error = "";
                            this.nominativo_lead = "";
                            this.telefono_lead = "";
                            this.email_lead = "";

                            let msg = new MessageChat()
                            this.client.sendMessage(msg.prepareSendMessage(MessageChat.TYPE_MESSAGE,0,"Richiesta Inviata! Sarai contattato al più presto.",0,this.chatID,defapp.TYPE_MESSAGE_AUTOMATIC,"",""))
                        }
                    })

                } else {
                    this.lead_error = "Inserire obbligatoriamente il nominativo ed almeno un contatto!";
                }
            },
            InviaRecapito()
            {
                if(this.telefono_contatto.length > 0 || this.email_contatto.length > 0)
                {
                    let body_message = "I miei recapiti: ";
                    if(this.telefono_contatto.length > 0)
                    {
                        body_message += "<br>Telefono: " + this.telefono_contatto;
                    }
                    if(this.email_contatto.length > 0)
                    {
                        body_message += "<br>Email: " + this.email_contatto;
                    }

                    let msg = new MessageChat()
                    this.client.sendMessage(msg.prepareSendMessage(MessageChat.TYPE_MESSAGE,0,body_message,0,this.chatID,defapp.TYPE_MESSAGE_AUTOMATIC,"",""))
                    this.$refs['modal-contatto'].hide();
                }
                else
                {
                    this.contatto_error = "Inserire obbligatoriamente almeno un contatto!";
                }
            }
        },
        computed: function(){  
            
        },
        mounted: function(){
            
        },
        created: function() { 
            
        }
    }

</script>